import { Controller } from "@hotwired/stimulus"

// Colapsa un bloque de texto a N líneas y muestra "Ver más" SÓLO si el texto
// realmente se desborda. Un toggle que no hace nada es peor que no tenerlo.
//
// Se usa en las transcripciones de audio: la mayoría son de una o dos líneas y
// no deberían mostrar ningún control.
export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = { maxLines: { type: Number, default: 3 } }

  connect() {
    this.expanded = false
    this.clamp()

    // El clamp depende de la altura renderizada, que puede cambiar cuando entra
    // una fuente o cuando el panel del chat cambia de ancho.
    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(() => this.updateToggleVisibility())
      this.observer.observe(this.element)
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  clamp() {
    if (!this.hasContentTarget) return

    this.contentTarget.style.webkitLineClamp = String(this.maxLinesValue)
    this.contentTarget.classList.add("audio-transcription__text--clamped")
    this.updateToggleVisibility()
  }

  updateToggleVisibility() {
    if (!this.hasContentTarget || !this.hasToggleTarget || this.expanded) return

    const overflows = this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 1
    this.toggleTarget.style.display = overflows ? "block" : "none"
  }

  toggle() {
    this.expanded = !this.expanded

    if (this.expanded) {
      this.contentTarget.classList.remove("audio-transcription__text--clamped")
      this.toggleTarget.textContent = "Ver menos"
    } else {
      this.contentTarget.classList.add("audio-transcription__text--clamped")
      this.toggleTarget.textContent = "Ver más"
    }
  }
}
